export default __webpack_public_path__ + "static/media/mentalHealth.24fecbf0.svg";